import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// styles
import { AvatarContainer, AvatarLinkStyled, AvatarStyled } from "./styles";

// components
import ThankYouBubble from "./ThankYouBubble";

const Avatar = () => {
    const { state } = useContext(AssetDownloadContext);

    const {
        asset: {
            creator: { username, name, avatarUrl }
        }
    } = state;

    const creatorProfilePath = `/${encodeURIComponent(username)}/`;

    return (
        <AvatarContainer>
            <ThankYouBubble isVisible />
            <AvatarLinkStyled href={creatorProfilePath}>
                <AvatarStyled src={avatarUrl} alt={`${name} Avatar`} />
            </AvatarLinkStyled>
        </AvatarContainer>
    );
};

export default Avatar;
